import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container, Row, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import './milestone-list.scss';
import { getMilestones, updateMilestones, getMilestonOperationData } from '../../store/actions';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import FormMilestone from './form-milestone';
import { transformCFColumns } from '../../helpers/tools_helper';
import { CancelButton } from '../../components/Common/iComponents/iPopUp/IpopUp';
import usePageTitle from '../../common/hooks/usePageTitle';

interface Foo {
    dataField: string;
    value: string;
}

const MilestoneList = (props: any) => {
    const dispatch = useDispatch();
    const { dataList, dataListOperation, milestoneConfig, isLoading } = useSelector((state: any) => state.Milestones);
    const PageTitleMS = usePageTitle(props.location.pathname);
    const [tableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [showTable, setshowTable] = useState(true);
    const groupName = '';
    const initialArrayTable = [
        {
            text: 'OperationName',
            dataField: 'OperationName',
            hidden: false,
        },
        {
            text: 'OperationType',
            dataField: 'OperationType',
            hidden: false,
        },
    ];
    const [milestoneList, setmilestoneList] = useState(initialArrayTable);
    useEffect(() => {
        setmilestoneList(dataList);
    }, [dataList]);

    const [operationData, setoperationData] = useState<any>({});
    const [classNameStick, setclassNameStick] = useState<any>('stickTitle');

    useEffect(() => {
        const listFinal = transformCFColumns(dataListOperation);
        console.log(" LF.. ", listFinal );
        console.log(" milestoneConfig.. ", milestoneConfig );

        const merged: Foo[] = Array.from(
            [...listFinal, ...milestoneConfig].reduce((acc, curr) => acc.set(curr.dataField, curr), new Map<Foo['dataField'], Foo>()).values(),
        );
        console.log("MERGRED:  ", merged)
        setoperationData(merged);
    }, [dataListOperation, milestoneConfig]);

    useEffect(() => {
        dispatch(getMilestones('SO'));
    }, []);

    const handleCreateClient = () => {};

    const toggleTable = () => {
        setshowTable(!showTable);
    };

    const handleUpdateClient = (data: any, notBack:boolean) => {
        const OperationType = selectedRow.OperationType;

        const dataUpdated = Object.values(data);
        dataUpdated.forEach((item: any) => {
            item.OperationType = OperationType;
            if (item.text == '') {
                item.text = item.dataField;
            }
        });
        dispatch(updateMilestones(dataUpdated));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        }).then(() => {
            if (!notBack) {
                toggleTable();
            }
        });
    };

    const handleDeleteClients = () => {};

    const handleCancelMilestone = () => {
        setpopUpState(!popUpState);
        toggleTable();
        setShowMessage({
            show: false,
            message: '',
        });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        getOperationData(row);
        setSelectedRow(row);
        setShowMessage({ show: false, message: '' });
    };

    const getOperationData = (row: any) => {
        dispatch(getMilestonOperationData(row));
        toggleTable();
    };

    const handleScroll = (event: { currentTarget: { scrollTop: any } }) => {
        if (event.currentTarget.scrollTop > 550) {
            setclassNameStick('stickTitleTop');
        } else {
            setclassNameStick('stickTitle');
        }
    };

    const [showMessage, setShowMessage] = useState({
        show: false,
        message: '',
    });

    useEffect(() => {
        if (isLoading && !showMessage.show) {
            setTimeout(() => {
                setShowMessage({
                    show: true,
                    message: 'Loading.',
                });
            }, 6000);
        } else {
            setShowMessage({
                show: false,
                message: '',
            });
        }
    }, [isLoading]);

    return (
        <React.Fragment>
            <div id="main">
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>{PageTitleMS.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid style={{ overflowY: 'auto' }} onScroll={handleScroll}>
                        <Row style={isLoading ? { overflow: 'hidden' } : {}}>
                            {showTable ? (
                                <Col lg="12">
                                    <ITable
                                        data={milestoneList}
                                        fields={initialArrayTable}
                                        tableColumns={initialArrayTable}
                                        enableDownload={false}
                                        pagSize={4}
                                        pageStartIn={0}
                                        showTotal={true}
                                        disablePageTitle={true}
                                        headerColorT={'bg-primary text-white'}
                                        tableViewList={tableViewList}
                                        groupName={groupName}
                                        handlePopUpState={onPopUpState}
                                        actionOnRowClick={handleActionOnRowClick}
                                        showPaginationTableProps={false}
                                    />
                                </Col>
                            ) : isLoading ? (
                                <div className="row justify-content-center pt-5">
                                    <div className="row justify-content-center pb-5 ">
                                        <Spinner
                                            className="mt-5 text-center"
                                            style={{
                                                height: '3rem',
                                                width: '3rem',
                                            }}
                                            color="primary"
                                        />
                                    </div>
                                    {showMessage.show ? <h6 className=" text-center">{showMessage.message}</h6> : null}

                                    <CancelButton className="btn button pb-2 mb-4" onClick={() => handleCancelMilestone()}>
                                        Cancel
                                    </CancelButton>
                                </div>
                            ) : Object.keys(operationData).length > 0 && !showTable ? (
                                <FormMilestone
                                    classNameStick={classNameStick}
                                    selectedRow={operationData}
                                    OperationName={selectedRow.OperationName}
                                    onCreate={handleCreateClient}
                                    onUpdate={handleUpdateClient}
                                    onDelete={handleDeleteClients}
                                    onCancel={handleCancelMilestone}
                                />
                            ) : (
                                <div className="row justify-content-center pt-5 mb-4">
                                    <div className="text-center pb-2">There is no information to display.</div>
                                    <CancelButton className="btn button" onClick={() => handleCancelMilestone()}>
                                        Cancel
                                    </CancelButton>
                                </div>
                            )}
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MilestoneList;
